/* Formulario COD (app Nivanu). Pedidos vía App Proxy /apps/nvnu/cod/*; el servidor recalcula precios y valida todo. */
(() => {
  const dialog = document.getElementById('NvnuCod');
  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const API = `${ROOT}apps/nvnu/cod`;
  const CONFIRM_URL = `${ROOT}pages/pedido-confirmado`;
  const money = (cents) => window.Chollazo.formatMoney(cents);
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const uuid = () => crypto.randomUUID();

  /* ---------- Atribución: datos del anuncio, en cookies propias de la tienda ---------- */
  const getCookie = (name) => document.cookie.split('; ').find((c) => c.startsWith(`${name}=`))?.slice(name.length + 1) || '';
  const setCookie = (name, value, days = 90) => {
    document.cookie = `${name}=${value}; Max-Age=${days * 86400}; Path=/; SameSite=Lax${location.protocol === 'https:' ? '; Secure' : ''}`;
  };
  const readAttribution = () => { try { return JSON.parse(decodeURIComponent(getCookie('nvnu_attr')) || '{}'); } catch { return {}; } };

  (function captureAttribution() {
    const params = new URLSearchParams(location.search);
    const fbclid = params.get('fbclid');
    if (fbclid && !getCookie('_fbc').endsWith(`.${fbclid}`)) setCookie('_fbc', `fb.1.${Date.now()}.${fbclid}`);
    if (!getCookie('_fbp')) setCookie('_fbp', `fb.1.${Date.now()}.${Math.floor(Math.random() * 1e10)}`);
    const utm = {};
    for (const k of ['source', 'medium', 'campaign', 'content', 'term']) { const v = params.get(`utm_${k}`); if (v) utm[k] = v.slice(0, 150); }
    const ttclid = params.get('ttclid');
    if (Object.keys(utm).length || ttclid) {
      const prev = readAttribution();
      setCookie('nvnu_attr', encodeURIComponent(JSON.stringify({ utm: Object.keys(utm).length ? utm : prev.utm || {}, ttclid: ttclid || prev.ttclid || null })));
    }
  })();

  renderConfirmation();
  if (!dialog) return;

  /* ---------- España ---------- */
  const PROVINCE_BY_PREFIX = { '01': 'VI', '02': 'AB', '03': 'A', '04': 'AL', '05': 'AV', '06': 'BA', '08': 'B', '09': 'BU', '10': 'CC', '11': 'CA', '12': 'CS', '13': 'CR', '14': 'CO', '15': 'C', '16': 'CU', '17': 'GI', '18': 'GR', '19': 'GU', '20': 'SS', '21': 'H', '22': 'HU', '23': 'J', '24': 'LE', '25': 'L', '26': 'LO', '27': 'LU', '28': 'M', '29': 'MA', '30': 'MU', '31': 'NA', '32': 'OR', '33': 'O', '34': 'P', '36': 'PO', '37': 'SA', '39': 'S', '40': 'SG', '41': 'SE', '42': 'SO', '43': 'T', '44': 'TE', '45': 'TO', '46': 'V', '47': 'VA', '48': 'BI', '49': 'ZA', '50': 'Z' };
  const NOT_SERVED = ['07', '35', '38', '51', '52'];
  const normalizePhone = (raw) => {
    let d = raw.replace(/[\s().-]/g, '');
    if (d.startsWith('+')) d = d.slice(1); else if (d.startsWith('00')) d = d.slice(2);
    if (!/^\d+$/.test(d)) return null;
    if (d.length === 11 && d.startsWith('34')) d = d.slice(2);
    if (/^[6789]\d{8}$/.test(d)) return `+34${d}`;
    // Modo prueba (ajuste del app): también acepta móviles de Brasil escritos con el 55 (9 dígitos, mismo criterio que el servidor).
    return S.config?.testMode && /^55[1-9]\d9\d{8}$/.test(d) ? `+${d}` : null;
  };
  const validEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
  // Máscara del teléfono: sin prefijo se agrupa como 612 34 56 78. Con +34 o 0034 se deja tal cual (solo caracteres válidos).
  const formatPhone = (raw) => {
    const clean = raw.replace(/[^\d+\s]/g, '');
    const digits = clean.replace(/\D/g, '');
    if (clean.includes('+') || digits.startsWith('00') || digits.length > 9 || (S.config?.testMode && digits.startsWith('55'))) return clean.replace(/\s+/g, ' ').trimStart();
    return [digits.slice(0, 3), digits.slice(3, 5), digits.slice(5, 7), digits.slice(7, 9)].filter(Boolean).join(' ');
  };
  let cpTable;
  const loadCpTable = () => (cpTable ||= fetch(window.NvnuAssets.cp).then((r) => r.json()).catch(() => { cpTable = null; return {}; }));

  const MESSAGES = {
    name: 'Escribe tu nombre y apellido.',
    phone: 'Introduce un teléfono de 9 dígitos, por ejemplo 612 34 56 78.',
    email: 'Revisa tu correo electrónico.',
    address1: 'Incluye la calle y el número (o s/n).',
    zip: 'Introduce un código postal válido.',
    zipNotServed: 'No realizamos envíos a Baleares, Canarias, Ceuta ni Melilla.',
    city: 'Introduce tu localidad.',
    province: 'La provincia no coincide con el código postal.',
    terms: 'Marca la casilla para continuar.',
    blocked: 'No podemos procesar este pedido. Escríbenos desde la página de contacto.',
    recent_order: 'Ya hemos recibido un pedido tuyo hace poco. Si quieres cambiar algo, escríbenos desde la página de contacto.',
    ip_limit: 'Hemos recibido varios pedidos desde tu conexión. Si necesitas ayuda, escríbenos desde la página de contacto.',
    max_quantity: (n) => `El máximo es de ${n} unidades por pedido.`,
    unavailable: 'Este producto ya no está disponible. Recarga la página.',
    server: 'Algo ha fallado. Inténtalo de nuevo en unos segundos.',
    config: 'No podemos tomar pedidos ahora mismo. Inténtalo de nuevo en unos minutos.',
  };

  /* ---------- Estado ---------- */
  const form = $('[data-nvnu-form]', dialog);
  const main = $('[data-nvnu-main]', dialog);
  const downsellPanel = $('[data-nvnu-downsell]', dialog);
  const alertBox = $('[data-nvnu-alert]', dialog);
  const submitBtn = $('[data-nvnu-submit]', dialog);
  const cardBtn = $('[data-nvnu-card]', dialog);
  const field = (name) => form.elements.namedItem(name);

  const S = {
    config: null, product: null, compareFallback: 0, units: 1, unitVariants: [],
    // downsell: nivel aceptado (0 ninguno, 1 o 2); closes: intentos de cierre. Viven mientras la página esté abierta.
    downsell: 0, closes: 0, timerEnd: 0, busy: false, requestId: null, requestKey: '', lastAbandon: '',
  };
  // Sesión del formulario y token del borrador de abandono (firmado por el servidor).
  const session = (() => {
    const read = (k) => { try { return localStorage.getItem(k); } catch { return null; } };
    const write = (k, v) => { try { if (v) localStorage.setItem(k, v); else localStorage.removeItem(k); } catch { /* sin almacenamiento */ } };
    let id = read('nvnu_session') || uuid();
    let draft = read('nvnu_draft');
    write('nvnu_session', id);
    return {
      get: () => id,
      draft: () => draft,
      setDraft: (token) => { draft = token; write('nvnu_draft', token); },
      renew: () => { id = uuid(); draft = null; write('nvnu_session', id); write('nvnu_draft', null); },
    };
  })();

  let configPromise;
  const loadConfig = () => (configPromise ||= fetch(`${API}/config`, { headers: { Accept: 'application/json' } })
    .then((r) => r.json()).then((c) => { if (!c.ok) throw new Error('config'); return c; })
    .catch((e) => { configPromise = null; throw e; }));

  /* ---------- Precios (mismo cálculo que el servidor) ---------- */
  const variantById = (id) => S.product.variants.find((v) => v.id === Number(id));
  const lines = () => {
    const counts = new Map();
    S.unitVariants.forEach((id) => counts.set(id, (counts.get(id) || 0) + 1));
    return [...counts].map(([id, quantity]) => ({ variantId: id, quantity, unitCents: variantById(id).price }));
  };
  const downsellPct = (level) => (level ? S.config.downsellDiscounts[level - 1] || 0 : 0);
  const offerPercent = (units) => S.config.offers.find((o) => o.units === units)?.percent || 0;
  const quote = (payment) => {
    const ls = lines();
    const subtotal = ls.reduce((n, l) => n + l.unitCents * l.quantity, 0);
    const units = ls.reduce((n, l) => n + l.quantity, 0);
    let remaining = subtotal;
    const discounts = []; // una línea por descuento, en el mismo orden que el servidor
    const apply = (label, pct) => {
      const cents = Math.round((remaining * pct) / 100);
      if (cents <= 0) return;
      discounts.push({ label, cents });
      remaining -= cents;
    };
    apply(`Oferta ${units} unidades (-${offerPercent(units)}%)`, offerPercent(units));
    if (S.downsell) apply(`Descuento extra (-${downsellPct(S.downsell)}%)`, downsellPct(S.downsell));
    if (payment === 'card') apply(`Pago con tarjeta (-${S.config.cardDiscount}%)`, S.config.cardDiscount);
    const shipping = shippingChoice() === 'priority' ? S.config.priorityShippingCents : 0;
    return { subtotal, discounts, shipping, total: remaining + shipping, units, lines: ls };
  };
  const shippingChoice = () => $('input[name="shipping"]:checked', form).value;

  /* ---------- Render ---------- */
  const el = (tag, attrs = {}, ...children) => {
    const node = document.createElement(tag);
    for (const [k, v] of Object.entries(attrs)) {
      if (v === false || v == null) continue;
      if (k === 'class') node.className = v; else if (k === 'text') node.textContent = v; else node.setAttribute(k, v === true ? '' : v);
    }
    node.append(...children.filter(Boolean));
    return node;
  };
  const img = (src, cls) => (src ? el('img', { class: cls, src: `${src}${src.includes('?') ? '&' : '?'}width=120`, alt: '', loading: 'lazy', width: 52, height: 52 }) : el('span', { class: cls }));

  const OFFER_TITLES = { 1: 'Compra 1 unidad' };
  const BADGES = { 1: ['Envío gratis', 'free'], 2: ['Más vendido', 'best'], 3: ['Más ahorro', 'save'] };

  function renderOffers() {
    const box = $('[data-nvnu-offers]', dialog);
    box.hidden = false;
    const list = $('[data-nvnu-offer-list]', box);
    const options = [1, ...S.config.offers.map((o) => o.units)];
    const base = variantById(S.unitVariants[0]);
    const wasUnit = Math.max(base.price, base.compare_at_price || 0, S.compareFallback);
    list.replaceChildren(...options.map((units) => {
      const pct = offerPercent(units);
      const full = base.price * units;
      const now = full - Math.round((full * pct) / 100);
      const was = wasUnit * units;
      const [badge, tone] = BADGES[units] || [];
      const input = el('input', { type: 'radio', name: 'offer', value: units, checked: units === S.units });
      const label = el('label', { class: 'nvnu-offer' },
        input, el('span', { class: 'nvnu-radio', 'aria-hidden': 'true' }),
        img((base.featured_image && base.featured_image.src) || S.product.featured_image, 'nvnu-offer__img'),
        el('span', { class: 'nvnu-offer__info' },
          el('span', { class: 'nvnu-offer__title', text: OFFER_TITLES[units] || `¡Compra ${units} unidades con un ${pct}% de descuento!` }),
          badge && el('span', { class: `nvnu-badge nvnu-badge--${tone}`, text: badge })),
        el('span', { class: 'nvnu-offer__price' }, el('strong', { text: money(now) }), was > now && el('s', { text: money(was) })));
      if (units === S.units && S.product.variants.length > 1) label.append(renderVariantPickers());
      return label;
    }));
  }

  function renderVariantPickers() {
    const wrap = el('span', { class: 'nvnu-offer__variants' });
    S.unitVariants.forEach((id, i) => {
      const select = el('select', { 'data-unit': i, 'aria-label': `Variante de la unidad ${i + 1}` },
        ...S.product.variants.filter((v) => v.available || v.id === id).map((v) => el('option', { value: v.id, selected: v.id === id, text: v.title })));
      wrap.append(el('span', { class: 'nvnu-offer__variant' }, el('span', { text: `${i + 1}.` }),
        el('span', { class: 'nvnu-field__control nvnu-field__control--select' }, select, chevron())));
    });
    return wrap;
  }
  const chevron = () => { const t = document.createElement('template'); t.innerHTML = window.NvnuAssets.chevron; return t.content.firstElementChild; };

  function renderTotals() {
    const q = quote('cod');
    $('[data-nvnu-subtotal]', dialog).textContent = money(q.subtotal);
    $$('[data-nvnu-discount-line]', dialog).forEach((n) => n.remove());
    $('[data-nvnu-shipping-row]', dialog).before(...q.discounts.map((d) => el('div', { class: 'nvnu-totals__save', 'data-nvnu-discount-line': true },
      el('dt', { text: d.label }), el('dd', { text: `-${money(d.cents)}` }))));
    $('[data-nvnu-shipping-cost]', dialog).textContent = q.shipping ? money(q.shipping) : 'Gratis';
    $('[data-nvnu-total]', dialog).textContent = money(q.total);
    $('[data-nvnu-cod-total]', dialog).textContent = money(q.total);
    $('[data-nvnu-priority-price]', dialog).textContent = money(S.config.priorityShippingCents);
    cardBtn.hidden = !(S.config.cardDiscount > 0);
    // Con otro descuento ya aplicado (oferta por cantidad o descuento extra), el de la tarjeta se suma: "+10%".
    $('[data-nvnu-card-pct]', dialog).textContent = `${q.discounts.length ? '+' : ''}${S.config.cardDiscount}`;
    $$('[data-nvnu-applied-pct]', dialog).forEach((n) => (n.textContent = downsellPct(S.downsell)));
    $('[data-nvnu-downsell-applied]', dialog).hidden = !S.downsell;
    // Con el nivel 2 aceptado, la cabecera muestra el contador en lugar del lema.
    $('[data-nvnu-head-default]', dialog).hidden = S.downsell === 2;
    $('[data-nvnu-head-final]', dialog).hidden = S.downsell !== 2;
  }

  const render = () => { renderOffers(); renderTotals(); };

  /* ---------- Validación ---------- */
  const fieldBox = (name) => $(`[data-field="${name}"]`, form);
  const errorEl = (name) => $(`#Nvnu${name[0].toUpperCase()}${name.slice(1)}Error`, form);
  function setError(name, message) {
    const input = field(name), err = errorEl(name);
    if (!input || !err) return;
    input.setAttribute('aria-invalid', message ? 'true' : 'false');
    if (message) input.setAttribute('aria-describedby', err.id); else input.removeAttribute('aria-describedby');
    err.textContent = message || '';
    err.hidden = !message;
  }
  const value = (name) => (field(name).value || '').trim().replace(/\s+/g, ' ');

  function check(name) {
    const v = value(name);
    switch (name) {
      case 'name': return v.split(' ').length >= 2 && /\p{L}/u.test(v) ? '' : MESSAGES.name;
      case 'phone': return normalizePhone(v) ? '' : MESSAGES.phone;
      case 'email': return !v || validEmail(v) ? '' : MESSAGES.email;
      // Número o "s/n" (sin número, habitual en zonas rurales). Mismo criterio que el servidor.
      case 'address1': return v.length >= 5 && (/\d/.test(v) || /\bs\s*\/?\s*n\b/i.test(v)) ? '' : MESSAGES.address1;
      case 'zip': {
        if (!/^\d{5}$/.test(v)) return MESSAGES.zip;
        if (NOT_SERVED.includes(v.slice(0, 2))) return MESSAGES.zipNotServed;
        return PROVINCE_BY_PREFIX[v.slice(0, 2)] ? '' : MESSAGES.zip;
      }
      case 'city': return v.length >= 2 ? '' : MESSAGES.city;
      case 'province': {
        const expected = PROVINCE_BY_PREFIX[value('zip').slice(0, 2)];
        return field('province').value && (!expected || expected === field('province').value) ? '' : MESSAGES.province;
      }
      case 'terms': return field('terms').checked ? '' : MESSAGES.terms;
      default: return '';
    }
  }
  const FIELDS = ['name', 'phone', 'email', 'address1', 'zip', 'city', 'province', 'terms'];
  // La casilla de aviso solo es obligatoria al pedir con pago en casa; con tarjeta no se exige.
  function validateAll(payment) {
    let first = null;
    if (payment === 'card') setError('terms', '');
    for (const name of payment === 'card' ? FIELDS.filter((n) => n !== 'terms') : FIELDS) {
      const msg = check(name);
      setError(name, msg);
      if (msg && !first) first = name;
    }
    if (first) {
      const input = field(first);
      input.focus({ preventScroll: true });
      (fieldBox(first) || input).scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
    return !first;
  }

  /* ---------- Código postal → provincia y ciudad ---------- */
  let autoCity = '';
  async function onZip() {
    const zipInput = field('zip');
    const digits = zipInput.value.replace(/\D/g, '').slice(0, 5);
    if (digits !== zipInput.value) zipInput.value = digits;
    // Baleares, Canarias, Ceuta y Melilla se avisan en cuanto se ven los dos primeros dígitos.
    if (digits.length >= 2 && NOT_SERVED.includes(digits.slice(0, 2))) { setError('zip', MESSAGES.zipNotServed); return; }
    if (digits.length < 5) { if (zipInput.getAttribute('aria-invalid') === 'true') setError('zip', ''); return; }
    const code = PROVINCE_BY_PREFIX[digits.slice(0, 2)];
    setError('zip', check('zip'));
    if (!code) return;
    field('province').value = code;
    setError('province', '');
    const entry = (await loadCpTable())[digits];
    const names = entry ? [].concat(entry) : [];
    // Con una sola localidad se rellena sin más; la lista solo se ofrece cuando el CP tiene varias (así no sale la flecha del datalist).
    $('#NvnuCityList').replaceChildren(...(names.length > 1 ? names : []).map((n) => el('option', { value: n })));
    const city = field('city');
    city.placeholder = names.length > 1 ? 'Elige tu localidad' : 'Ej: Madrid';
    if (names.length === 1 && (!city.value.trim() || city.value === autoCity)) {
      city.value = autoCity = names[0];
      setError('city', '');
    } else if (names.length > 1 && (!city.value.trim() || city.value === autoCity)) {
      city.value = autoCity = '';
      city.focus({ preventScroll: true });
      try { city.showPicker(); } catch { /* el navegador no abre la lista solo: se muestra al escribir */ }
    }
  }

  /* ---------- Payload ---------- */
  const customerData = () => ({
    name: value('name'), phone: value('phone'), email: value('email'), address1: value('address1'),
    address2: value('address2'), zip: value('zip'), city: value('city'), province: field('province').value,
  });
  const items = () => lines().map(({ variantId, quantity }) => ({ variantId, quantity }));

  function tracking(eventId) {
    const attr = readAttribution();
    return {
      eventId, fbp: getCookie('_fbp') || null, fbc: getCookie('_fbc') || null, ttp: getCookie('_ttp') || null,
      ttclid: attr.ttclid || null, utm: attr.utm || {}, pageUrl: location.href.split('#')[0],
    };
  }

  const post = (path, body, keepalive = false) => fetch(`${API}/${path}`, {
    method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body), keepalive,
  });

  /* ---------- ¿El teléfono tiene WhatsApp? ---------- */
  // Se comprueba en segundo plano al completar el número; mientras tanto el campo queda bloqueado y el resto del
  // formulario sigue libre. Solo un "no" explícito abre la confirmación: error, demora o sin respuesta no muestran nada.
  const WA_TIMEOUT_MS = 6000;
  const WA_SUBMIT_WAIT_MS = 3000; // el botón de pago en casa espera, como mucho, a una comprobación en curso
  const phoneConfirm = $('[data-nvnu-phone-confirm]', dialog);
  const wa = { results: new Map(), confirmed: new Set(), pending: null, pendingPhone: null, asking: null, askedPhone: null, resolveAsk: null };
  const wait = (ms) => new Promise((r) => setTimeout(r, ms));

  function setPhoneChecking(on) {
    const input = field('phone');
    input.readOnly = on;
    input.closest('.nvnu-field__control').classList.toggle('is-checking', on);
    if (on) input.setAttribute('aria-busy', 'true'); else input.removeAttribute('aria-busy');
  }

  function checkWhatsapp(phone) {
    if (wa.results.has(phone) || wa.pendingPhone === phone) return;
    const ctrl = new AbortController();
    const timer = setTimeout(() => ctrl.abort(), WA_TIMEOUT_MS);
    setPhoneChecking(true);
    wa.pendingPhone = phone;
    const request = fetch(`${API}/whatsapp`, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ phone }), signal: ctrl.signal,
    }).then((r) => r.json()).then((d) => (d.ok && typeof d.exists === 'boolean' ? d.exists : null)).catch(() => null)
      .then((exists) => {
        clearTimeout(timer);
        // "Sin respuesta" también se guarda: el botón de pedir no vuelve a esperar por el mismo número.
        wa.results.set(phone, exists);
        if (wa.pending === request) { wa.pending = null; wa.pendingPhone = null; setPhoneChecking(false); }
        // Durante el envío del pedido quien decide es phoneConfirmed(); aquí solo se avisa mientras se rellena.
        if (exists === false && !S.busy && dialog.open && normalizePhone(value('phone')) === phone) askPhone(phone);
        return exists;
      });
    wa.pending = request;
  }

  function askPhone(phone) {
    if (wa.confirmed.has(phone)) return Promise.resolve(true);
    if (wa.asking) return wa.asking;
    wa.askedPhone = phone;
    $('[data-nvnu-phone-confirm-number]', phoneConfirm).textContent = value('phone');
    wa.asking = new Promise((resolve) => { wa.resolveAsk = resolve; });
    phoneConfirm.showModal();
    $('[data-nvnu-phone-ok]', phoneConfirm).focus({ preventScroll: true });
    return wa.asking;
  }

  function answerPhone(correct) {
    if (!wa.asking) return;
    if (correct) wa.confirmed.add(wa.askedPhone);
    const resolve = wa.resolveAsk;
    wa.asking = wa.resolveAsk = null;
    if (phoneConfirm.open) phoneConfirm.close();
    resolve(correct);
    if (!correct) {
      const input = field('phone');
      input.focus({ preventScroll: true });
      input.select();
      (fieldBox('phone') || input).scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
  }
  $('[data-nvnu-phone-ok]', phoneConfirm).addEventListener('click', () => answerPhone(true));
  $('[data-nvnu-phone-fix]', phoneConfirm).addEventListener('click', () => answerPhone(false));
  phoneConfirm.addEventListener('cancel', (e) => { e.preventDefault(); answerPhone(false); });

  // La comprobación empieza al dejar de escribir (o al salir del campo): bloquear el campo a mitad del número
  // se comería las últimas teclas.
  const WA_TYPING_PAUSE_MS = 600;
  let waTimer;
  function checkPhoneNow() {
    clearTimeout(waTimer);
    const phone = normalizePhone(value('phone'));
    if (phone) checkWhatsapp(phone);
  }
  function schedulePhoneCheck() {
    clearTimeout(waTimer);
    waTimer = setTimeout(checkPhoneNow, WA_TYPING_PAUSE_MS);
  }

  // Antes de pedir con pago en casa: true para seguir. Con un "no" sin confirmar, pregunta y sigue solo con "Sí".
  async function phoneConfirmed() {
    const phone = normalizePhone(value('phone'));
    if (!phone || wa.confirmed.has(phone)) return true;
    checkPhoneNow(); // si aún no se comprobó (pedido justo después de escribir), empieza ya
    if (wa.pendingPhone === phone) {
      S.busy = true;
      submitBtn.classList.add('is-loading');
      submitBtn.setAttribute('aria-busy', 'true');
      try { await Promise.race([wa.pending, wait(WA_SUBMIT_WAIT_MS)]); } finally {
        S.busy = false;
        submitBtn.classList.remove('is-loading');
        submitBtn.removeAttribute('aria-busy');
      }
    }
    return wa.results.get(phone) === false ? askPhone(phone) : true;
  }

  /* ---------- Formulario abandonado: se guarda mientras se rellena (una petición a la vez) ---------- */
  let abandonTimer, abandonInFlight = null, abandonAgain = false;
  async function sendAbandon() {
    if (S.done || S.busy) return;
    if (abandonInFlight) { abandonAgain = true; return; }
    const c = customerData();
    if (!normalizePhone(c.phone) && !validEmail(c.email)) return;
    const body = { sessionId: session.get(), token: session.draft(), items: items(), shipping: shippingChoice(), customer: c };
    const key = JSON.stringify(body);
    if (key === S.lastAbandon) return;
    abandonInFlight = post('abandon', body, true).then((r) => r.json())
      .then((data) => { if (data.ok) { S.lastAbandon = key; session.setDraft(data.token); } })
      .catch(() => { /* se reintenta en el próximo cambio */ });
    await abandonInFlight;
    abandonInFlight = null;
    if (abandonAgain) { abandonAgain = false; sendAbandon(); }
  }
  function saveAbandon(now = false) {
    clearTimeout(abandonTimer);
    if (now) sendAbandon(); else abandonTimer = setTimeout(sendAbandon, 1200);
  }

  /* ---------- Píxeles en el navegador (mismo ID de evento que el servidor) ---------- */
  function meta(id) {
    if (!id) return null;
    if (!window.fbq) {
      /* eslint-disable */
      !function (f, b, e, v, n, t, s) { if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); }; if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = []; t = b.createElement(e); t.async = !0; t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s); }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      /* eslint-enable */
    }
    meta.inited ||= new Set();
    if (!meta.inited.has(id)) { window.fbq('init', id); meta.inited.add(id); }
    return (event, data, eventId) => window.fbq('trackSingle', id, event, data, { eventID: eventId });
  }
  function tiktok(id) {
    if (!id) return null;
    if (!window.ttq) {
      /* eslint-disable */
      !function (w, d, t) { w.TiktokAnalyticsObject = t; var ttq = w[t] = w[t] || []; ttq.methods = ['page', 'track', 'identify', 'instances', 'debug', 'on', 'off', 'once', 'ready', 'alias', 'group', 'enableCookie', 'disableCookie', 'holdConsent', 'revokeConsent', 'grantConsent']; ttq.setAndDefer = function (t, e) { t[e] = function () { t.push([e].concat(Array.prototype.slice.call(arguments, 0))); }; }; for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]); ttq.instance = function (t) { for (var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++) ttq.setAndDefer(e, ttq.methods[n]); return e; }; ttq.load = function (e, n) { var r = 'https://analytics.tiktok.com/i18n/pixel/events.js'; ttq._i = ttq._i || {}, ttq._i[e] = [], ttq._i[e]._u = r, ttq._t = ttq._t || {}, ttq._t[e] = +new Date(), ttq._o = ttq._o || {}, ttq._o[e] = n || {}; var o = d.createElement('script'); o.type = 'text/javascript', o.async = !0, o.src = r + '?sdkid=' + e + '&lib=' + t; var a = d.getElementsByTagName('script')[0]; a.parentNode.insertBefore(o, a); }; }(window, document, 'ttq');
      /* eslint-enable */
    }
    tiktok.loaded ||= new Set();
    if (!tiktok.loaded.has(id)) { window.ttq.load(id); tiktok.loaded.add(id); }
    return (event, data, eventId) => window.ttq.instance(id).track(event, data, { event_id: eventId });
  }
  function track(event, q, eventId) {
    const contents = q.lines.map((l) => ({ id: String(l.variantId), quantity: l.quantity, item_price: l.unitCents / 100 }));
    const value = q.total / 100, currency = S.config.currency;
    meta(S.config.metaPixelId)?.(event, { value, currency, contents, content_type: 'product', num_items: q.units }, eventId);
    tiktok(S.config.tiktokPixelId)?.(event, { value, currency, content_type: 'product', contents: contents.map((c) => ({ content_id: c.id, quantity: c.quantity, price: c.item_price })) }, eventId);
  }

  /* ---------- Envío del pedido ---------- */
  const showAlert = (msg) => { alertBox.textContent = msg || ''; alertBox.hidden = !msg; if (msg) alertBox.scrollIntoView({ block: 'center', behavior: 'smooth' }); };

  async function submit(payment) {
    if (S.busy) return;
    showAlert('');
    if (!validateAll(payment)) return;
    // Solo el pago en casa se confirma por WhatsApp; con tarjeta no se espera ni se pregunta.
    if (payment === 'cod' && !(await phoneConfirmed())) return;
    const button = payment === 'card' ? cardBtn : submitBtn;
    const other = button === cardBtn ? submitBtn : cardBtn;
    S.busy = true;
    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');
    other.disabled = true;
    try {
      const base = { sessionId: session.get(), items: items(), shipping: shippingChoice(), downsell: S.downsell, terms: field('terms').checked, customer: customerData() };
      const key = `${payment}:${JSON.stringify(base)}`;
      if (key !== S.requestKey) { S.requestKey = key; S.requestId = uuid(); }
      const eventId = S.requestId;
      clearTimeout(abandonTimer);
      await abandonInFlight; // el token del borrador debe estar actualizado para borrarlo al crear el pedido
      const res = await post(payment === 'card' ? 'card' : 'order', { ...base, requestId: S.requestId, abandonToken: session.draft(), tracking: tracking(eventId) });
      const data = await res.json().catch(() => ({ ok: false, error: 'server' }));
      if (!data.ok) return handleError(data);
      // El pedido ya existe: desde aquí nada puede mostrar un error al cliente ni impedir la redirección.
      S.done = true;
      if (payment === 'card') { session.renew(); location.href = data.invoiceUrl; return; }
      try {
        const q = quote('cod');
        track('Purchase', { ...q, total: data.totalCents }, eventId);
        saveConfirmation(data.order.name, q);
      } catch { /* píxel o almacenamiento fallaron; la página de confirmación muestra el mensaje genérico */ }
      session.renew();
      location.href = CONFIRM_URL;
    } catch {
      showAlert(MESSAGES.server);
    } finally {
      if (!S.done) {
        S.busy = false;
        button.classList.remove('is-loading');
        button.removeAttribute('aria-busy');
        other.disabled = false;
      }
    }
  }

  function handleError(data) {
    if (data.error === 'invalid' && data.field && FIELDS.includes(data.field)) {
      setError(data.field, MESSAGES[data.field]);
      field(data.field).focus();
      return;
    }
    if (data.error === 'max_quantity') return showAlert(MESSAGES.max_quantity(S.config.maxQuantity));
    showAlert(MESSAGES[data.error] || MESSAGES.server);
  }

  function saveConfirmation(orderName, q) {
    const c = customerData();
    const priority = shippingChoice() === 'priority';
    const linesOut = q.lines.map((l) => { const v = variantById(l.variantId); return { title: S.product.title, variant: S.product.variants.length > 1 ? v.title : null, quantity: l.quantity, image: (v.featured_image && v.featured_image.src) || S.product.featured_image }; });
    const provinceName = field('province').selectedOptions[0]?.textContent || '';
    try {
      sessionStorage.setItem('nvnu_done', JSON.stringify({
        order: orderName, firstName: c.name.split(' ')[0], total: money(q.total), email: c.email || null,
        shipping: priority ? 'Envío prioritario · entre 12 y 24 h' : 'Envío gratis · entre 24 y 48 h',
        address: [c.name, c.address1, c.address2, `${c.zip} ${c.city}`, provinceName].filter(Boolean),
        lines: linesOut,
      }));
    } catch { /* sin almacenamiento: la página muestra el mensaje genérico */ }
  }

  /* ---------- Abrir y cerrar ---------- */
  async function open(detail = {}) {
    if (dialog.open) return;
    const root = $('[data-product]');
    const json = root && $('[data-product-json]', root);
    if (!json) return;
    S.product = JSON.parse(json.textContent);
    S.compareFallback = parseInt(root.dataset.compareFallback || '0', 10) || 0;
    const current = variantById(detail.variantId || $('form[data-product-form] input[name="id"]', root)?.value) || S.product.variants.find((v) => v.available);
    if (!current || !current.available) return;
    S.units = 1;
    S.unitVariants = [current.id];
    try {
      S.config = await loadConfig().catch(() => new Promise((r) => setTimeout(r, 800)).then(loadConfig)); // un reintento ante fallos puntuales de red
    } catch {
      window.alert(MESSAGES.config);
      return;
    }
    // El descuento aceptado y los intentos de cierre se mantienen al reabrir; solo se reinician al recargar la página.
    S.requestKey = '';
    showAlert('');
    hideDownsell();
    render();
    document.body.classList.add('is-locked');
    dialog.showModal();
    main.scrollTop = 0;
    track('InitiateCheckout', quote('cod'), uuid());
  }

  function close() {
    saveAbandon(true);
    dialog.close();
  }
  dialog.addEventListener('close', () => {
    if (!document.querySelector('.drawer.is-open, .search-modal.is-open')) document.body.classList.remove('is-locked');
  });

  /* ---------- Downsell (dos niveles) y contador ---------- */
  const DOWNSELL_TEXT = {
    1: { title: '¡Espera!', sub: '¡Tenemos una oferta para ti!' },
    2: { title: '¡Última oportunidad!', sub: 'Solo para ti, durante los próximos 5 minutos' },
  };
  const TIMER_MS = 5 * 60 * 1000;
  const URGENT_SECONDS = 120;
  let shownLevel = 0;
  let timerId;

  // Solo visual: al llegar a cero se queda en 00:00 y el descuento sigue aplicado.
  function tick() {
    const left = Math.max(0, Math.ceil((S.timerEnd - Date.now()) / 1000));
    const text = `${String(Math.floor(left / 60)).padStart(2, '0')}:${String(left % 60).padStart(2, '0')}`;
    $$('[data-nvnu-timer]', dialog).forEach((n) => { n.textContent = text; n.classList.toggle('is-urgent', left < URGENT_SECONDS); });
    if (!left) clearInterval(timerId);
  }
  function startTimer() {
    if (S.timerEnd) return;
    S.timerEnd = Date.now() + TIMER_MS;
    tick();
    timerId = setInterval(tick, 1000);
  }

  function downsellImage() {
    const src = variantById(S.unitVariants[0])?.featured_image?.src || S.product.featured_image;
    return src ? el('img', { src: `${src}${src.includes('?') ? '&' : '?'}width=400`, alt: '', width: 200, height: 200 }) : null;
  }
  function showDownsell(level) {
    shownLevel = level;
    const text = DOWNSELL_TEXT[level];
    $('[data-nvnu-ds-title]', dialog).textContent = text.title;
    $('[data-nvnu-ds-sub]', dialog).textContent = text.sub;
    $$('[data-nvnu-ds-pct]', dialog).forEach((n) => (n.textContent = downsellPct(level)));
    $('[data-nvnu-ds-timer]', dialog).hidden = level !== 2;
    if (level === 2) startTimer();
    $('[data-nvnu-downsell-media]', dialog).replaceChildren(...[downsellImage()].filter(Boolean));
    downsellPanel.classList.toggle('is-final', level === 2);
    if (level === 2) dialog.classList.add('is-shaking');
    form.classList.add('is-downsell');
    main.hidden = true;
    downsellPanel.hidden = false;
    $('[data-nvnu-downsell-accept]', dialog).focus({ preventScroll: true });
  }
  function hideDownsell() {
    form.classList.remove('is-downsell');
    downsellPanel.hidden = true;
    main.hidden = false;
  }

  // Solo se cierra con la X (o Esc); clicar fuera no cierra. Cada intento cuenta: el 1.º ofrece el nivel 1 y el 2.º
  // el nivel 2, si da más descuento que el ya aceptado. Con el nivel 2 aceptado ya no se ofrece nada más.
  function attemptClose() {
    if (S.busy) return;
    if (S.config && S.downsell !== 2 && S.closes < 2) {
      S.closes += 1;
      const level = S.closes;
      if (downsellPct(level) > downsellPct(S.downsell)) { showDownsell(level); return; }
    }
    close();
  }

  dialog.addEventListener('animationend', (e) => { if (e.target === dialog) dialog.classList.remove('is-shaking'); });
  dialog.addEventListener('cancel', (e) => { e.preventDefault(); if (downsellPanel.hidden) attemptClose(); else close(); });
  $('[data-nvnu-close]', dialog).addEventListener('click', attemptClose);
  $$('[data-nvnu-downsell-decline]', dialog).forEach((b) => b.addEventListener('click', close));
  $('[data-nvnu-downsell-accept]', dialog).addEventListener('click', () => {
    S.downsell = shownLevel;
    hideDownsell();
    renderTotals();
    main.scrollTop = 0;
    submitBtn.focus({ preventScroll: true });
  });

  form.addEventListener('submit', (e) => { e.preventDefault(); submit('cod'); });
  cardBtn.addEventListener('click', () => submit('card'));

  form.addEventListener('change', (e) => {
    const t = e.target;
    if (t.name === 'offer') {
      S.units = Number(t.value);
      const first = S.unitVariants[0];
      S.unitVariants = Array.from({ length: S.units }, (_, i) => S.unitVariants[i] || first);
      renderOffers();
      renderTotals();
      $(`input[name="offer"][value="${S.units}"]`, dialog).focus({ preventScroll: true });
    } else if (t.dataset.unit != null) {
      S.unitVariants[Number(t.dataset.unit)] = Number(t.value);
      renderTotals();
    } else if (t.name === 'shipping') {
      renderTotals();
    } else if (t.name === 'province' || t.name === 'terms') {
      setError(t.name, check(t.name));
    }
    saveAbandon();
  });
  form.addEventListener('input', (e) => {
    const t = e.target;
    if (t.name === 'phone') {
      // Solo se reformatea al escribir al final del campo, para no mover el cursor a mitad del número.
      if (t.selectionStart === t.value.length) t.value = formatPhone(t.value);
      schedulePhoneCheck();
    }
    if (t.name === 'zip') onZip();
    else if (FIELDS.includes(t.name) && t.getAttribute('aria-invalid') === 'true') setError(t.name, check(t.name));
    saveAbandon();
  });
  form.addEventListener('focusout', (e) => {
    const name = e.target.name;
    if (name === 'phone') checkPhoneNow();
    if (FIELDS.includes(name) && name !== 'terms' && e.target.value.trim()) setError(name, check(name));
  });

  document.addEventListener('nvnu:open', (e) => open(e.detail));
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'hidden' && dialog.open) saveAbandon(true); });

  // En la ficha de producto se adelanta la configuración para abrir el formulario sin espera.
  if (document.querySelector('[data-product-json]')) {
    (window.requestIdleCallback || setTimeout)(() => loadConfig().catch(() => {}));
  }

  /* ---------- Página de pedido confirmado ---------- */
  function renderConfirmation() {
    const page = document.querySelector('[data-nvnu-done]');
    if (!page) return;
    let data = null;
    try { data = JSON.parse(sessionStorage.getItem('nvnu_done') || 'null'); } catch { /* sin datos */ }
    if (!data) return;
    const set = (sel, text) => { const n = page.querySelector(sel); if (n) n.textContent = text; };
    set('[data-done-title]', `¡Gracias, ${data.firstName}!`);
    set('[data-done-order]', `Hemos recibido tu pedido ${data.order}.`);
    set('[data-done-pay]', `Pagas ${data.total} al recibirlo, sin adelantar nada.`);
    set('[data-done-shipping]', data.shipping);
    const address = page.querySelector('[data-done-address]');
    if (address) address.replaceChildren(...data.address.flatMap((line, i) => (i ? [document.createElement('br'), line] : [line])));
    const list = page.querySelector('[data-done-lines]');
    if (list) {
      list.replaceChildren(...data.lines.map((l) => {
        const li = document.createElement('li');
        li.className = 'nvnu-item';
        const pic = document.createElement('img');
        pic.className = 'nvnu-item__ph';
        pic.alt = '';
        if (l.image) pic.src = `${l.image}${l.image.includes('?') ? '&' : '?'}width=120`;
        const info = document.createElement('span');
        const t = document.createElement('span'); t.className = 'nvnu-item__title'; t.textContent = l.title;
        const m = document.createElement('span'); m.className = 'nvnu-item__meta'; m.textContent = `${l.variant ? `${l.variant} · ` : ''}Cantidad: ${l.quantity}`;
        info.append(t, document.createElement('br'), m);
        li.append(pic, info);
        return li;
      }));
    }
    page.querySelectorAll('[data-done-detail]').forEach((n) => (n.hidden = false));
  }
})();
